import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
//CSS & styles
import "../style.less";

import signature from "../img/signature.png";

// antd components
import { Button, Form, message, Row } from "antd";

class SignUpForm2 extends React.Component {
  constructor(props) {
    super(props);
    //var ctx = this;

    //initialisation des states. Ils ne servent que de manière "temporaire" (test de condition pour "vider" les champs grâce
    // aux fonctions EmitEmpty.
    // Afin d'être persistants, ils doivent se transformer en props via le dispatch du Formulaire.

    this.state = {};
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((error, values) => {
      if (error) {
        message.error("Le formulaire est incomplet");
      } else {
        message.success("Bienvenue !");
        this.props.submitForm();
      }
    });
  };

  render() {
    const redirectToSignUp = this.props.user.redirectToSignUp;
    if (redirectToSignUp === false) {
      return <Redirect to="/profile" />;
    }

    return (
      <div style={{ alignContent: "center", width: "100%", padding: "30px" }}>
        <Form onSubmit={this.handleSubmit2}>
          <p
            style={{
              marginVertical: "30px",
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center"
            }}
          >
            Merci de votre intérêt pour Urban Fitness ! Nos administrateurs vont
            bientôt vous attribuer une équipe et un coach pour que vous puissiez
            commencer à travailler.{" "}
          </p>
          <Row
            type="flex"
            justify="center"
            style={{ marginBottom: "30px", marginTop: "30px" }}
          >
            <img
              src={signature}
              style={{ width: "329px", height: "130px" }}
              alt="signatureSarah"
            />
          </Row>
          <Row type="flex" justify="center">
            <Button
              htmltype="submit"
              type="primary"
              onClick={this.handleSubmit}
            >
              {" "}
              Continuer{" "}
            </Button>
          </Row>
        </Form>
      </div>
    );
  }
}

const WrappedSignUpForm2 = Form.create()(SignUpForm2);

const mapStateToProps = globalReducers => globalReducers;

const mapDispatchToProps = dispatch => {
  return {
    submitForm: values => {
      dispatch({ type: "USERS_SIGNUP_SUCCESS" });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedSignUpForm2);
